import { useResponsive } from '../../../hooks/use-responsive';
import type { ModuleSkeletonProps } from '../../../vars';
import FahrzeugsucheListSidebarSkeleton from './skeleton-sidebar';
import FahrzeugsucheListTopSkeleton from './skeleton-top';

export default function FahrzeugsucheListSkeleton(props: ModuleSkeletonProps) {
    const { rootContainer, settings } = props;
    const md = useResponsive(rootContainer, 'down', 'lg');
    const useTopFilter = md || settings?.fahrzeugsuche?.topFilter || false;

    return useTopFilter ? <FahrzeugsucheListTopSkeleton {...props} /> : <FahrzeugsucheListSidebarSkeleton {...props} />;
}
